export const EVALUATOR_TYPES = {
  EXTERNAL_EVALUATOR: 'ExternalEvaluator',
  INTERNAL_EVALUATOR: 'InternalEvaluator'
};